import axios from "axios";
import { ExperiencesAvailabilityRequest } from "redmond";
import { config } from "../../config";
import { experiencesAvailabilityApiPrefix } from "../paths";

export const fetchExperiencesAvailability = async (
  body: ExperiencesAvailabilityRequest
): Promise<ExperiencesAvailabilityRequest> => {
  const res = await axios.post(experiencesAvailabilityApiPrefix, body, {
    baseURL: config.baseURL,
  });

  return res.data.value;
};
